import SEO from "@/components/SEO";
import { Btn } from "@/components/primitives";
import GrowthRing from "@/components/visuals/GrowthRing";
import { brand } from "@/content/site";
import { CheckCircle2 } from "lucide-react";

export default function ThankYou() {
  return (
    <>
      <SEO
        title="Thank You | Green Circle Group"
        description="Your Growth Assessment request has been received."
        path="/thank-you"
        noindex
      />
      <section className="relative bg-forest min-h-[80vh] flex items-center overflow-hidden py-28">
        <div
          aria-hidden="true"
          className="pointer-events-none absolute -left-32 -bottom-24 opacity-40"
        >
          <GrowthRing size={460} colorFrom="#2CD59C" colorTo="#8DFE3F" duration={90} />
        </div>
        <div className="relative mx-auto max-w-2xl px-5 sm:px-8 text-center">
          <div className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-lime text-forest">
            <CheckCircle2 className="h-9 w-9" />
          </div>
          <h1 className="mt-8 text-4xl md:text-5xl font-extrabold tracking-tight text-white text-balance">
            Thank you. Your Growth Assessment request is on its way.
          </h1>
          <p className="mt-6 text-lg text-white/80 leading-relaxed">
            We have received your information and will contact you using the
            details provided. In the meantime, take a look at how the Green
            Circle growth system works.
          </p>
          <div className="mt-9 flex flex-col sm:flex-row justify-center gap-4">
            <Btn to="/how-it-works" size="lg" data-testid="thankyou-how-btn">
              See How It Works
            </Btn>
            <a
              href={`mailto:${brand.email}`}
              className="inline-flex items-center justify-center text-white/80 font-semibold hover:text-lime transition-colors"
            >
              {brand.email}
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
